import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import momentHelper from 'scoreboard/components/moment-helper'
import permissions from 'scoreboard/components/permissions'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'
import user from 'scoreboard/components/user'

var InitiativeArchiveActions = Backbone.View.extend({

	events: {
		'click .archive-action': 'click',
		'click .hide-banner': 'hideBanner'
	},

	/**
	 *  Usage: new InitiativeArchiveActions({ el: this.$('.banner-archive'), model: this.model })
	 *
	 * @constructs
	 * @param {function} [options.onChange] Can be provided by the caller to be
	 * notified when an archive action has been triggered, which may affect the
	 * state of the model.
	 */
	initialize: function(options) {
		this.options = options || {}
		this.model.on('save:status remove:status', this.render.bind(this))
	},

	render: function () {
		// If user closed the banner during the session, don't show the banner.
		// #22007 if the init is replicated don't show the banner
		if (sessionStorage.getItem('hideArchiveBanner') == user.model.id ||
			!_.isNil(this.model.get('syncId'))) {
			return
		}

		var orgId = this.model.get('organizationId')
		var complete = this.model.get('aggregatedCompletionDate')
		var archived = this.isArchived()
		if (complete || archived) {
			var key = 'initiatives.archive.banner' + (!archived ? '' : '.archived')
			var typeLabel = i18n.get('initiatives.type.' + this.model.get('type'))
			var linkText = ''
			if (permissions.archiveInitiatives(orgId)) {
				this.$el.removeClass('is-not-displayed')

				var actionKey = 'initiatives.archive.banner.action.' + this.getArchiveAction()
				linkText = '<a class="text-link archive-action">' +
						   _.escape(i18n.get(actionKey)) +
						   '</a>'
				this.$el.html(i18n.get(key, typeLabel, linkText))
			} else if (archived) {
				this.$el.html(i18n.get('initiatives.archive.banner.archived.viewonly', typeLabel))
				this.$el.removeClass('is-not-displayed')
			}
			this.$el.append(`<span class="hide-banner">${icon('cross')}</span>`)
		}
		return this
	},

	isArchived: function() {
		return !_.isUndefined(this.model.get('archiveDate'))
	},

	/**
	 * Returns the action to take if the user clicks on the archive action
	 * @returns {string} 'archive' or 'unarchive'
	 */
	getArchiveAction: function() {
		return this.isArchived() ? 'unarchive' : 'archive'
	},

	// If user clicks the "x" to hide the banner, don't show it for the remainder of the session.
	// Applies to both the overview and edit screens.
	hideBanner() {
		this.$el.addClass('is-not-displayed')
		sessionStorage.setItem('hideArchiveBanner', user.model.id)
	},

	click: function (e) {
		// change the UI right away

		// save this value for later, because we're about to change it
		let archiveAction = this.getArchiveAction()
		// important: don't set silent: true, because initiatives-edit is
		// listening for the change:archiveDate event
		this.model.unset('archiveDate')
		if (archiveAction === 'archive') {
			this.model.set('archiveDate', momentHelper.isoDate(new Date()))
		}
		Backbone.trigger('edit:domain-object', this.model, {archiveAction})

		// make it so on the server
		$.ajax({
			method: 'post',
			url: 'api/initiatives/' + this.model.get('id') + '/' + archiveAction,
			success: function (data) {
				this.render()
			}.bind(this)
		})
	}
})

export default InitiativeArchiveActions

InitiativeArchiveActions.__filename__ = 'initiatives/initiatives-archive-actions.js'
